import { render, staticRenderFns } from "./tablequestion.vue?vue&type=template&id=8304e8fc&scoped=true"
import script from "./tablequestion.vue?vue&type=script&lang=js"
export * from "./tablequestion.vue?vue&type=script&lang=js"
import style0 from "./tablequestion.vue?vue&type=style&index=0&id=8304e8fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8304e8fc",
  null
  
)

export default component.exports